import styled from 'styled-components';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';
import Image from 'global/Image';

const SMainContainer = styled.div`
  background: ${color.light};
  border-top: 1px solid ${color.gainsboro};
  border: unset;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding: 20px;
  position: relative;
  row-gap: 25px;
  width: auto;
  border-radius: 3px;

  @media ${device.tablet} {
    border: 1px solid ${color.gainsboro};
    justify-content: space-evenly;
    gap: 24px;
  }
`;

// pane component
const SPaneContainer = styled.div`
  position: relative;
  display: block;
  padding: 20px;
  width: 95%;
  background: ${color.light};
  border: 1px solid ${color.gainsboro};
  border-radius: 3px;
`;

const SPaneHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
`;

const SPaneHeaderWrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
`;

const SPaneTitle = styled(Text).attrs({ family: 'bold' })`
  position: relative;
  display: block;
  margin-bottom: 0px;
  font-size: 18px;
  color: rgb(51, 51, 51);
`;

const SPaneBody = styled.div`
  position: relative;
  display: block;
  overflow: hidden;
`;

const SPaneCover = styled(Image)`
  position: relative;
  display: block;
  float: left;
  width: 150px;
  margin: 5px 18px 18px 0px;
`;

const SCardContainer = styled.div`
  position: relative;
  display: block;
  width: 133px;
`;

const SCard = styled(Flex)`
  position: relative;
  display: block;
  width: 100%;
  border-radius: 3px;
  max-width: ${(props) =>
    // @ts-expect-error
    (props.isPaneActive ? '80px' : '130px')};
  overflow: hidden;
  &:hover {
    cursor: pointer;
  }
`;

const SCardImg = styled(Image)`
  width: 100%;
  overflow: hidden;
  height: ${(props) => (props.isPaneActive ? '80px' : '130px')};
  overflow: hidden;

  &:hover {
    transform: scale(1.1);
  }
`;

const SCardTitle = styled.h5`
  position: relative;
  margin: 0px;
  padding: 5px;
  text-align: center;
  height: 75px;
  overflow: hidden;
  color: ${color.dimGray};
  background: ${color.aliceBlue};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export {
  SMainContainer,
  SPaneContainer,
  SPaneBody,
  SPaneCover,
  SPaneHeader,
  SPaneHeaderWrapper,
  SPaneTitle,
  SCard,
  SCardContainer,
  SCardImg,
  SCardTitle,
};
